/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Src_2_DetailInputs */

const en_wb_support_src_2_detail = /** @type {(inputs: Wb_Support_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10:00 and 14:30 open`)
};

const lv_wb_support_src_2_detail = /** @type {(inputs: Wb_Support_Src_2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brīvs 10:00 un 14:30`)
};

/**
* | output |
* | --- |
* | "10:00 and 14:30 open" |
*
* @param {Wb_Support_Src_2_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_src_2_detail = /** @type {((inputs?: Wb_Support_Src_2_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Src_2_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_src_2_detail(inputs)
	return en_wb_support_src_2_detail(inputs)
});